import type { FC } from 'react';
import React, { useEffect } from 'react';

import type { TFields } from '../form/models';
import { useFormSafe } from '../form/context';

import type { IProps } from './models';

export const HiddenInput: FC<IProps> = ({ dataTestId, name = '', value = '' }) => {
    const formApi = useFormSafe<TFields>();

    useEffect(() => formApi?.change(name, value), [name, value]);

    return <input data-test-id={dataTestId} name={name} type="hidden" value={value} />;
};
